import React from "react";

const HeroComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default HeroComponent;
